import { Button, Form, Modal, Popconfirm, Steps, Card, message } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { AppSettingsContext, FormContext } from '../../Shared/Contexts';
import { applyNameToForm, reusableSubmitValidatorWithKeys } from '../../Shared/Functions';
import { allFormKeys } from './FormKeys';
import dayjs from 'dayjs';
import SequentialMessageNotifier from '../../Shared/Functions/SequentialMessageNotifier';
import { CreateClient, EditClient } from '../../Shared/Services';
import Guardians from './Guardians';
import Services from './Services';
import Therapists from './Therapists';
import Languages from './Languages';
import PersonalAndAddress from './PersonalAndAddress';

const { Step } = Steps;

const ClientForm = ({
    formType,
    setFormType,
    visibility,
    setVisibility,
    highlighted,
    handleAfterFormSubmit
}) => {
    const [form] = Form.useForm();
    const { formContext, setFormContext } = useContext(FormContext);
    const [page, setPage] = useState(0)
    const [loading, setLoading] = useState(false);
    const [notesVisible, setNotesVisible] = useState(false);

    useEffect(() => {
        if (visibility) {
            if (highlighted?.checkNotes) {
                setNotesVisible(true);
            }
            if (formType === 'edit') {
                console.log(highlighted);
                const ifspDate = dayjs(highlighted.ifspDate, 'YYYY-MM-DD');
                const fiveMonthsLater = ifspDate.add(5, "month");
                const tenMonthsLater = ifspDate.add(10, "month");

                applyNameToForm(setFormContext, "SC", highlighted.serviceCoordinatorName);

                applyNameToForm(setFormContext, "DT", highlighted.developmentalTherapistName);
                applyNameToForm(setFormContext, "DTC", highlighted.dtcName);
                applyNameToForm(setFormContext, "DTSupervisor", highlighted.dtSupervisorName);

                applyNameToForm(setFormContext, "OT", highlighted.occupationalTherapistName);
                applyNameToForm(setFormContext, "COTA", highlighted.cotaName);
                applyNameToForm(setFormContext, "COTASupervisor", highlighted.cotaSupervisorName);

                applyNameToForm(setFormContext, "PT", highlighted.physicalTherapistName);
                applyNameToForm(setFormContext, "PTA", highlighted.ptaName);
                applyNameToForm(setFormContext, "PTASupervisor",highlighted.ptaSupervisorName);

                applyNameToForm(setFormContext, "SLP", highlighted.speechTherapistName);
                applyNameToForm(setFormContext, "SLPCF", highlighted.slpcfName);

                applyNameToForm(setFormContext, "EdTeamOne", highlighted.edTeamOneName);
                applyNameToForm(setFormContext, "EdTeamTwo", highlighted.edTeamTwoName);
                applyNameToForm(setFormContext, "EdTeamThree", highlighted.edTeamThreeName);

                form.setFieldsValue({
                    firstStepsId: highlighted?.firstStepsId,
                    ifspDate: highlighted.ifspDate ? dayjs(highlighted.ifspDate, 'YYYY-MM-DD') : null,
                    active: highlighted?.active,
                    annualIFSPDate: highlighted.annualIFSPDate ? dayjs(highlighted.annualIFSPDate, 'YYYY-MM-DD') : null,
                    firstName1: highlighted.firstName1 ? highlighted.firstName1 : '',
                    firstName2: highlighted.firstName2 ? highlighted.firstName2 : '',
                    preferredName: highlighted.preferredName ? highlighted.preferredName : '',
                    lastName1: highlighted.lastName1 ? highlighted.lastName1 : '',
                    lastName2: highlighted.lastName2 ? highlighted.lastName2 : '',
                    lastNameHyphenated: highlighted.lastNameHyphenated ? highlighted.lastNameHyphenated : false,
                    county: highlighted.county ? highlighted.county.toString() : '0',
                    dateOfBirth: highlighted.dateOfBirth ? dayjs(highlighted.dateOfBirth, 'YYYY-MM-DD') : '',
                    ageOut: highlighted.ageOut ? dayjs(highlighted.ageOut, 'YYYY-MM-DD') : '',
                    address: highlighted.address ? highlighted.address : '',
                    city: highlighted.city ? highlighted.city : '',
                    zipcode: highlighted.zipcode ? highlighted.zipcode : '',
                    parentOneFirstName1: highlighted.parentOneFirstName1 ? highlighted.parentOneFirstName1 : '',
                    parentOneFirstName2: highlighted.parentOneFirstName2 ? highlighted.parentOneFirstName2 : '',
                    parentOnePreferredName: highlighted.parentOnePreferredName ? highlighted.parentOnePreferredName : '',
                    parentOneLastName1: highlighted.parentOneLastName1 ? highlighted.parentOneLastName1 : '',
                    parentOneLastName2: highlighted.parentOneLastName2 ? highlighted.parentOneLastName2 : '',
                    parentOneLastNameHyphenated: highlighted.parentOneLastNameHyphenated ? highlighted.parentOneLastNameHyphenated : false,
                    parentOneEmail: highlighted.parentOneEmail ? highlighted.parentOneEmail : '',
                    parentOneAddress1: highlighted.parentOneAddress1 ? highlighted.parentOneAddress1 : '',
                    parentOneAddress2: highlighted.parentOneAddress2 ? highlighted.parentOneAddress2 : '',
                    parentOneCity: highlighted.parentOneCity ? highlighted.parentOneCity : '',
                    parentOneState: highlighted.parentOneState ? highlighted.parentOneState : '',
                    parentOneZipcode: highlighted.parentOneZipcode ? highlighted.parentOneZipcode : '',
                    parentOnePhone: highlighted.parentOnePhone ? highlighted.parentOnePhone : '',
                    parentOneNotes: highlighted.parentOneNotes ? highlighted.parentOneNotes : '',
                    parentTwoFirstName1: highlighted.parentTwoFirstName1 ? highlighted.parentTwoFirstName1 : '',
                    parentTwoFirstName2: highlighted.parentTwoFirstName2 ? highlighted.parentTwoFirstName2 : '',
                    parentTwoPreferredName: highlighted.parentTwoPreferredName ? highlighted.parentTwoPreferredName : '',
                    parentTwoLastName1: highlighted.parentTwoLastName1 ? highlighted.parentTwoLastName1 : '',
                    parentTwoLastName2: highlighted.parentTwoLastName2 ? highlighted.parentTwoLastName2 : '',
                    parentTwoLastNameHyphenated: highlighted.parentTwoLastNameHyphenated ? highlighted.parentTwoLastNameHyphenated : false,
                    parentTwoEmail: highlighted.parentTwoEmail ? highlighted.parentTwoEmail : '',
                    parentTwoAddress1: highlighted.parentTwoAddress1 ? highlighted.parentTwoAddress1 : '',
                    parentTwoAddress2: highlighted.parentTwoAddress2 ? highlighted.parentTwoAddress2 : '',
                    parentTwoCity: highlighted.parentTwoCity ? highlighted.parentTwoCity : '',
                    parentTwoState: highlighted.parentTwoState ? highlighted.parentTwoState : '',
                    parentTwoZipcode: highlighted.parentTwoZipcode ? highlighted.parentTwoZipcode : '',
                    parentTwoPhone: highlighted.parentTwoPhone ? highlighted.parentTwoPhone : '',
                    parentTwoNotes: highlighted.parentTwoNotes ? highlighted.parentTwoNotes : '',
                    fosterParentFirstName1: highlighted.fosterParentFirstName1 ? highlighted.fosterParentFirstName1 : '',
                    fosterParentFirstName2: highlighted.fosterParentFirstName2 ? highlighted.fosterParentFirstName2 : '',
                    fosterParentPreferredName: highlighted.fosterParentPreferredName ? highlighted.fosterParentPreferredName : '',
                    fosterParentLastName1: highlighted.fosterParentLastName1 ? highlighted.fosterParentLastName1 : '',
                    fosterParentLastName2: highlighted.fosterParentLastName2 ? highlighted.fosterParentLastName2 : '',
                    fosterParentLastNameHyphenated: highlighted.fosterParentLastNameHyphenated ? highlighted.fosterParentLastNameHyphenated : false,
                    fosterParentEmail: highlighted.fosterParentEmail ? highlighted.fosterParentEmail : '',
                    fosterParentAddress1: highlighted.fosterParentAddress1 ? highlighted.fosterParentAddress1 : '',
                    fosterParentAddress2: highlighted.fosterParentAddress2 ? highlighted.fosterParentAddress2 : '',
                    fosterParentCity: highlighted.fosterParentCity ? highlighted.fosterParentCity : '',
                    fosterParentState: highlighted.fosterParentState ? highlighted.fosterParentState : '',
                    fosterParentZipcode: highlighted.fosterParentZipcode ? highlighted.fosterParentZipcode : '',
                    fosterParentPhone: highlighted.fosterParentPhone ? highlighted.fosterParentPhone : '',
                    fosterParentNotes: highlighted.fosterParentNotes ? highlighted.fosterParentNotes : '',
                    guardianAdLitumParentFirstName1: highlighted.guardianAdLitumParentFirstName1 ? highlighted.guardianAdLitumParentFirstName1 : '',
                    guardianAdLitumFirstName2: highlighted.guardianAdLitumFirstName2 ? highlighted.guardianAdLitumFirstName2 : '',
                    guardianAdLitumPreferredName: highlighted.guardianAdLitumPreferredName ? highlighted.guardianAdLitumPreferredName : '',
                    guardianAdLitumLastName1: highlighted.guardianAdLitumLastName1 ? highlighted.guardianAdLitumLastName1 : '',
                    guardianAdLitumLastName2: highlighted.guardianAdLitumLastName2 ? highlighted.guardianAdLitumLastName2 : '',
                    guardianAdLitumLastNameHyphenated: highlighted.guardianAdLitumLastNameHyphenated ? highlighted.guardianAdLitumLastNameHyphenated : false,
                    guardianAdLitumEmail: highlighted.guardianAdLitumEmail ? highlighted.guardianAdLitumEmail : '',
                    guardianAdLitumAddress1: highlighted.guardianAdLitumAddress1 ? highlighted.guardianAdLitumAddress1 : '',
                    guardianAdLitumAddress2: highlighted.guardianAdLitumAddress2 ? highlighted.guardianAdLitumAddress2 : '',
                    guardianAdLitumCity: highlighted.guardianAdLitumCity ? highlighted.guardianAdLitumCity : '',
                    guardianAdLitumState: highlighted.guardianAdLitumState ? highlighted.guardianAdLitumState : '',
                    guardianAdLitumZipcode: highlighted.guardianAdLitumZipcode ? highlighted.guardianAdLitumZipcode : '',
                    guardianAdLitumPhone: highlighted.guardianAdLitumPhone ? highlighted.guardianAdLitumPhone : '',
                    guardianAdLitumNotes: highlighted.guardianAdLitumNotes ? highlighted.guardianAdLitumNotes : '',
                    guardianFirstName1: highlighted.guardianFirstName1 ? highlighted.guardianFirstName1 : '',
                    guardianFirstName2: highlighted.guardianFirstName2 ? highlighted.guardianFirstName2 : '',
                    guardianPreferredName: highlighted.guardianPreferredName ? highlighted.guardianPreferredName : '',
                    guardianLastName1: highlighted.guardianLastName1 ? highlighted.guardianLastName1 : '',
                    guardianLastName2: highlighted.guardianLastName2 ? highlighted.guardianLastName2 : '',
                    guardianLastNameHyphenated: highlighted.guardianAdLitumLastNameHyphenated ? highlighted.guardianAdLitumLastNameHyphenated : false,
                    guardianEmail: highlighted.guardianEmail ? highlighted.guardianEmail : '',
                    guardianAddress1: highlighted.guardianAddress1 ? highlighted.guardianAddress1 : '',
                    guardianAddress2: highlighted.guardianAddress2 ? highlighted.guardianAddress2 : '',
                    guardianCity: highlighted.guardianCity ? highlighted.guardianCity : '',
                    guardianState: highlighted.guardianState ? highlighted.guardianState : '',
                    guardianZipcode: highlighted.guardianZipcode ? highlighted.guardianZipcode : '',
                    guardianPhone: highlighted.guardianPhone ? highlighted.guardianPhone : '',
                    guardianNotes: highlighted.guardianNotes ? highlighted.guardianNotes : '',
                    serviceCoordinatorId: highlighted.serviceCoordinatorId ? highlighted.serviceCoordinatorId : null,
                    serviceCoordinatorNotes: highlighted.serviceCoordinatorNotes ? highlighted.serviceCoordinatorNotes : '',
                    virtualVisit: highlighted?.virtualVisit,
                    dTConsult: highlighted.dtConsult ? dayjs(highlighted.dtConsult, 'YYYY=MM-DD') : '',
                    oTConsult: highlighted.otConsult ? dayjs(highlighted.otConsult, 'YYYY=MM-DD') : '',
                    pTConsult: highlighted.ptConsult ? dayjs(highlighted.ptConsult, 'YYYY=MM-DD') : '',
                    sTConsult: highlighted.stConsult ? dayjs(highlighted.stConsult, 'YYYY=MM-DD') : '',
                    dTNeeded: highlighted?.dtNeeded,
                    oTNeeded: highlighted?.otNeeded,
                    pTNeeded: highlighted?.ptNeeded,
                    sTNeeded: highlighted?.stNeeded,
                    dTFulfilled: highlighted?.dtFulfilled,
                    dTAFulfilled: highlighted?.dtaFulfilled,
                    oTFulfilled: highlighted?.otFulfilled,
                    cOTAFulfilled: highlighted?.cotaFulfilled,
                    pTFulfilled: highlighted?.ptFulfilled,
                    pTAFulfilled: highlighted?.ptaFulfilled,
                    sTFulfilled: highlighted?.stFulfilled,
                    sLPCFFulfilled: highlighted?.slpcfFulfilled,
                    initialReferralDate: highlighted.initialReferralDate ? dayjs(highlighted.initialReferralDate, 'YYYY-MM-DD') : '',
                    consultReferral1Date: highlighted.consultReferral1Date ? dayjs(highlighted.consultReferral1Date, 'YYYY-MM-DD') : '',
                    consultReferral2Date: highlighted.consultReferral2Date ? dayjs(highlighted.consultReferral2Date, 'YYYY-MM-DD') : '',
                    consultReferral3Date: highlighted.consultReferral3Date ? dayjs(highlighted.consultReferral3Date, 'YYYY-MM-DD') : '',
                    consultReferral4Date: highlighted.consultReferral4Date ? dayjs(highlighted.consultReferral4Date, 'YYYY-MM-DD') : '',
                    ongoingReferral1Date: highlighted.ongoingReferral1Date ? dayjs(highlighted.ongoingReferral1Date, 'YYYY-MM-DD') : '',
                    ongoingReferral2Date: highlighted.ongoingReferral2Date ? dayjs(highlighted.ongoingReferral2Date, 'YYYY-MM-DD') : '',
                    ongoingReferral3Date: highlighted.ongoingReferral3Date ? dayjs(highlighted.ongoingReferral3Date, 'YYYY-MM-DD') : '',
                    ongoingReferral4Date: highlighted.ongoingReferral4Date ? dayjs(highlighted.ongoingReferral4Date, 'YYYY-MM-DD') : '',
                    addonReferral1Date: highlighted.addonReferral1Date ? dayjs(highlighted.addonReferral1Date, 'YYYY-MM-DD') : '',
                    addonReferral2Date: highlighted.addonReferral2Date ? dayjs(highlighted.addonReferral2Date, 'YYYY-MM-DD') : '',
                    addonReferral3Date: highlighted.addonReferral3Date ? dayjs(highlighted.addonReferral3Date, 'YYYY-MM-DD') : '',
                    addonReferral4Date: highlighted.addonReferral4Date ? dayjs(highlighted.addonReferral4Date, 'YYYY-MM-DD') : '',
                    caseManagementNotes: highlighted.caseManagementNotes ? highlighted.caseManagementNotes : '',
                    supplementalDate1: highlighted.supplementalDate1 ? dayjs(highlighted.supplementalDate1, 'YYYY-MM-DD') : '',
                    supplementalService1: highlighted.supplementalService1 ? highlighted.supplementalService1 : 0,
                    supplementalDate2: highlighted.supplementalDate2 ? dayjs(highlighted.supplementalDate2, 'YYYY-MM-DD') : '',
                    supplementalService2: highlighted.supplementalService2 ? highlighted.supplementalService2 : 0,
                    supplementalDate3: highlighted.supplementalDate3 ? dayjs(highlighted.supplementalDate3, 'YYYY-MM-DD') : '',
                    supplementalService3: highlighted.supplementalService3 ? highlighted.supplementalService3 : 0,
                    supplementalDate4: highlighted.supplementalDate4 ? dayjs(highlighted.supplementalDate4, 'YYYY-MM-DD') : '',
                    supplementalService4: highlighted.supplementalService3 ? highlighted.supplementalService4 : 0,
                    doctorSignature: highlighted.doctorSignature ? highlighted.doctorSignature : '',
                    doctorName: highlighted.doctorName ? highlighted.doctorName : '',
                    doctorFax: highlighted.doctorFax ? highlighted.doctorFax : '',
                    doctorPhone: highlighted.doctorPhone ? highlighted.doctorPhone : '',
                    dTServicesStartBy: highlighted.dtServicesStartBy ? dayjs(highlighted.dtServicesStartBy, 'YYYY-MM-DD') : '',
                    dTInitialIFSPDateSOS: highlighted.dtInitialIFSPDateSOS ? dayjs(highlighted.dtInitialIFSPDateSOS, 'YYYY-MM-DD') : '',
                    dTProviderSOSDate: highlighted.dtProviderSOSDate ? dayjs(highlighted.dtProviderSOSDate, 'YYYY-MM-DD') : '',
                    dTDateAssigned: highlighted.dtDateAssigned ? dayjs(highlighted.dtDateAssigned, 'YYYY-MM-DD') : '',
                    dTServiceFromAnotherAgency: highlighted?.dtServiceFromAnotherAgency,
                    developmentalTherapistId: highlighted.developmentalTherapistId ? highlighted.developmentalTherapistId.toString() : null,
                    dtFrequency: highlighted.dtFrequency ? highlighted.dtFrequency : 0,
                    dtFrequencyMinutes: highlighted.dtFrequencyMinutes ? highlighted.dtFrequencyMinutes: 0,
                    dtcId: highlighted.dtcId ? highlighted.dtcId.toString() : null,
                    dtcFrequency: highlighted.dtcFrequency ? highlighted.dtcFrequency : 0,
                    dtcFrequencyMinutes: highlighted.dtcFrequencyMinutes ? highlighted.dtcFrequencyMinutes : 0,
                    dtcSupervisorId: highlighted.dtcSupervisorId ? highlighted.dtcSupervisorId.toString() : null,
                    oTServicesStartBy: highlighted.otServicesStartBy ? dayjs(highlighted.otServicesStartBy, 'YYYY-MM-DD') : '',
                    oTInitialIFSPDateSOS: highlighted.otInitialIFSPDateSOS ? dayjs(highlighted.otInitialIFSPDateSOS, 'YYYY-MM-DD') : '',
                    oTProviderSOSDate: highlighted.otProviderSOSDate ? dayjs(highlighted.otProviderSOSDate, 'YYYY-MM-DD') : '',
                    oTDateAssigned: highlighted.otDateAssigned ? dayjs(highlighted.otDateAssigned, 'YYYY-MM-DD') : '',
                    oTServiceFromAnotherAgency: highlighted?.otServiceFromAnotherAgency,
                    occupationalTherapistId: highlighted.occupationalTherapistId ? highlighted?.occupationalTherapistId.toString() : null,
                    otFrequency: highlighted.otFrequency ? highlighted.otFrequency : 0,
                    otFrequencyMinutes: highlighted.otFrequencyMinutes ? highlighted.otFrequencyMinutes : 0,
                    cotaId: highlighted.cotaId ? highlighted.cotaId.toString() : null,
                    cotaFrequency: highlighted.cotaFrequency ? highlighted.cotaFrequency : 0,
                    cotaFrequencyMinutes: highlighted.cotaFrequencyMinutes ? highlighted.cotaFrequencyMinutes : 0,
                    cotaSupervisorId: highlighted.cotaSupervisorId ? highlighted.cotaSupervisorId.toString() : null,
                    pTServicesStartBy: highlighted.ptServicesStartBy ? dayjs(highlighted.ptServicesStartBy, 'YYYY-MM-DD') : '',
                    pTInitialIFSPDateSOS: highlighted.ptInitialIFSPDateSOS ? dayjs(highlighted.ptInitialIFSPDateSOS, 'YYYY-MM-DD') : '',
                    pTProviderSOSDate: highlighted.ptProviderSOSDate ? dayjs(highlighted.ptProviderSOSDate, 'YYYY-MM-DD') : '',
                    pTDateAssigned: highlighted.ptDateAssigned ? dayjs(highlighted.ptDateAssigned, 'YYYY-MM-DD') : '',
                    pTServiceFromAnotherAgency: highlighted?.ptServiceFromAnotherAgency,
                    physicalTherapistId: highlighted.physicalTherapistId ? highlighted.physicalTherapistId.toString() : null,
                    ptFrequency: highlighted.ptFrequency ? highlighted.ptFrequency : 0,
                    ptFrequencyMinutes: highlighted.ptFrequencyMinutes ? highlighted.ptFrequencyMinutes : 0,
                    ptaId: highlighted.ptaId ? highlighted.ptaId.toString() : null,
                    ptaFrequency: highlighted.ptaFrequency ? highlighted.ptaFrequency : 0,
                    ptaFrequencyMinutes: highlighted.ptaFrequencyMinutes ? highlighted.ptaFrequencyMinutes : 0,
                    ptaSupervisorId: highlighted.ptaSupervisorId ? highlighted.ptaSupervisorId.toString() : null,
                    sTServicesStartBy: highlighted.stServicesStartBy ? dayjs(highlighted.stServicesStartBy, 'YYYY-MM-DD') : '',
                    sTInitialIFSPDateSOS: highlighted.stInitialIFSPDateSOS ? dayjs(highlighted.stInitialIFSPDateSOS, 'YYYY-MM-DD') : '',
                    sTProviderSOSDate: highlighted.stProviderSOSDate ? dayjs(highlighted.stProviderSOSDate, 'YYYY-MM-DD') : '',
                    sTDateAssigned: highlighted.stDateAssigned ? dayjs(highlighted.stDateAssigned, 'YYYY-MM-DD') : '',
                    sTServiceFromAnotherAgency: highlighted?.stServiceFromAnotherAgency,
                    speechTherapistId: highlighted.speechTherapistId ? highlighted.speechTherapistId.toString() : null,
                    stFrequency: highlighted.stFrequency ? highlighted.stFrequency : 0,
                    stFrquencyMinutes: highlighted.stFrquencyMinutes ? highlighted.stFrquencyMinutes : 0,
                    slpcfId: highlighted.slpcfId ? highlighted.slpcfId.toString() : null,
                    slpcfFrequency: highlighted.slpcfFrequency ? highlighted.slpcfFrequency : 0,
                    slpcfFrequencyMinutes: highlighted.slpcfFrequencyMinutes ? highlighted.slpcfFrequencyMinutes : 0,
                    quaterlyReport5Month: highlighted.quaterlyReport5Month ? dayjs(highlighted.quaterlyReport5Month, 'YYYY-MM-DD') : fiveMonthsLater,
                    quarterlyReport10Month: highlighted.quarterlyReport10Month ? dayjs(highlighted.quarterlyReport10Month, 'YYYY-MM-DD') : tenMonthsLater,
                    otherReport: highlighted.otherReport ? dayjs(highlighted.otherReport, 'YYYY-MM-DD') : '',
                    dischargeReport: highlighted.dischargeReport ? dayjs(highlighted.dischargeReport, 'YYYY-MM-DD') : '',
                    exitSkills: highlighted.exitSkills ? highlighted.exitSkills : '',
                    notes: highlighted.notes ? highlighted.notes : '',
                    burmese: highlighted?.burmese,
                    chin: highlighted?.chin,
                    falamChin: highlighted?.falamChin,
                    hakhaChin: highlighted?.hakhaChin,
                    matuChin: highlighted?.matuChin,
                    tedimChin: highlighted?.tedimChin,
                    zanniatChin: highlighted?.zanniatChin,
                    zopheiChin: highlighted?.zopheiChin,
                    crioulo: highlighted?.crioulo,
                    filipino: highlighted?.filipino,
                    french: highlighted?.french,
                    frenchCajun: highlighted?.frenchCajun,
                    frenchCanadian: highlighted?.frenchCanadian,
                    haitainCreole: highlighted?.haitainCreole,
                    german: highlighted?.german,
                    punjabi: highlighted?.punjabi,
                    spanish: highlighted?.spanish,
                    vietnamese: highlighted?.vietnamese,
                    somali: highlighted?.somali,
                    swahili: highlighted?.swahili,
                    otherLanguage: highlighted.otherLanguage ? highlighted.otherLanguage : '',
                    referralStatus: highlighted?.referralStatus ? highlighted?.referralStatus.toString() : '0',
                    checkNotes: highlighted?.checkNotes,
                    edTeamId1: highlighted.edTeamId1 ? highlighted.edTeamId1.toString() : null,
                    edTeamId2: highlighted.edTeamId2 ? highlighted.edTeamId2.toString() : null,
                    edTeamId3: highlighted.edTeamId3 ? highlighted.edTeamId3.toString() : null
                });
                console.log("formContext", formContext);
            } else {
                form.setFieldsValue({
                    firstStepsId: "",
                    active: true,
                    annualIFSPDate: "",
                    lastNameHyphenated: false,
                    county: '0',
                    dateOfBirth: "",
                    ageOut: "",
                    virtualVisit: false,
                    dTConsult: "",
                    oTConsult: "",
                    pTConsult: "",
                    sTConsult: "",
                    dTNeeded: false,
                    oTNeeded: false,
                    pTNeeded: false,
                    sTNeeded: false,
                    dTFulfilled: false,
                    dTAFulfilled: false,
                    oTFulfilled: false,
                    cOTAFulfilled: false,
                    pTFulfilled: false,
                    pTAFulfilled: false,
                    sTFulfilled: false,
                    sLPCFFulfilled: false,
                    initialReferralDate: "",
                    consultReferral1Date: "",
                    consultReferral2Date: "",
                    consultReferral3Date: "",
                    consultReferral4Date: "",
                    ongoingReferral1Date: "",
                    ongoingReferral2Date: "",
                    ongoingReferral3Date: "",
                    ongoingReferral4Date: "",
                    addonReferral1Date: "",
                    addonReferral2Date: "",
                    addonReferral3Date: "",
                    addonReferral4Date: "",
                    // caseManagementNotes: highlighted.caseManagementNotes,
                    supplementalDate1: "",
                    supplementalService1: 0,
                    supplementalDate2: "",
                    supplementalService2: 0,
                    supplementalDate3: "",
                    supplementalService3: 0,
                    supplementalDate4: "",
                    supplementalService4: 0,
                    // doctorSignature: highlighted.doctorSignature,
                    dTServicesStartBy: "",
                    dTInitialIFSPDateSOS: "",
                    dTProviderSOSDate: "",
                    dTDateAssigned: "",
                    dTServiceFromAnotherAgency: false,
                    developmentalTherapistId: null,
                    dtcId: null,
                    dtcSupervisorId: null,
                    oTServicesStartBy: "",
                    oTInitialIFSPDateSOS: "",
                    oTProviderSOSDate: "",
                    oTDateAssigned: "",
                    oTServiceFromAnotherAgency: false,
                    occupationalTherapistId: null,
                    cotaId: null,
                    cotaSupervisorId: null,
                    pTServicesStartBy: "",
                    pTInitialIFSPDateSOS: "",
                    pTProviderSOSDate: "",
                    pTDateAssigned: "",
                    pTServiceFromAnotherAgency: false,
                    physicalTherapistId: null,
                    ptaId: null,
                    ptaSupervisorId: null,
                    sTServicesStartBy: "",
                    sTInitialIFSPDateSOS: "",
                    sTProviderSOSDate: "",
                    sTDateAssigned: "",
                    sTServiceFromAnotherAgency: false,
                    speechTherapistId: null,
                    slpcfId: null,
                    quaterlyReport5Month: dayjs().add(5, 'month'),
                    quarterlyReport10Month: dayjs().add(10, 'month'),
                    otherReport: "",
                    dischargeReport: "",
                    // exitSkills: highlighted.exitSkills,
                    // notes: highlighted.notes,
                    burmese: false,
                    chin: false,
                    falamChin: false,
                    hakhaChin: false,
                    matuChin: false,
                    tedimChin: false,
                    zanniatChin: false,
                    zopheiChin: false,
                    crioulo: false,
                    filipino: false,
                    french: false,
                    frenchCajun: false,
                    frenchCanadian: false,
                    haitainCreole: false,
                    german: false,
                    punjabi: false,
                    spanish: false,
                    vietnamese: false,
                    somali: false,
                    swahili: false,
                    referralStatus: "0",
                    checkNotes: false,
                    dtcFrequency: 0,
                    dtcFrequencyMinutes: 0,
                    dtcSupervisorFrequency: 0,
                    dtcSupervisorFrequencyMinutes: 0,
                    otFrequency: 0,
                    otFrequencyMinutes: 0,
                    ptFrequency: 0,
                    ptFrequencyMinutes: 0,
                    ptaFrequency: 0,
                    ptaFrequencyMinutes: 0,
                    ptaSupervisorFrequency: 0,
                    ptaSupervisorFrequencyMinutes: 0,
                    slpcfFrequency: 0,
                    slpcfFrequencyMinutes: 0,
                    stFrequency: 0,
                    stFrquencyMinutes: 0
                })
            }
        }
    }, [visibility]);

    const onClose = () => {
        form.resetFields();
        setVisibility(false);
        setFormType();
        setFormContext({});
        setPage(0);
    }

    const onNotesCancel = () => {
        setNotesVisible(false);
        onClose();
    }

    const onNotesAcknowledge = () => {
        setNotesVisible(false);
    }

    const putRequest = () => {
        form.validateFields(allFormKeys).then(values => {
            SequentialMessageNotifier(formType);
            console.log("Active?", values?.active);
            setLoading(true);
            values = {
                ...values,
                active: values.active,
                ifspDate: values.ifspDate ? dayjs(values.ifspDate).format('YYYY-MM-DD') : '',
                annualIFSPDate: values.annualIFSPDate ? dayjs(values.annualIFSPDate).format('YYYY-MM-DD') : '',
                dateOfBirth: values.dateOfBirth ? dayjs(values.dateOfBirth).format('YYYY-MM-DD') : '',
                ageOut: values.ageOut ? dayjs(values.ageOut).format('YYYY-MM-DD') : '',
                dTConsult: values.dTConsult ? dayjs(values.dTConsult).format('YYYY-MM-DD') : '',
                oTConsult: values.oTConsult ? dayjs(values.oTConsult).format('YYYY-MM-DD') : '',
                pTConsult: values.pTConsult ? dayjs(values.pTConsult).format('YYYY-MM-DD') : '',
                sTConsult: values.sTConsult ? dayjs(values.sTConsult).format('YYYY-MM-DD') : '',
                initialReferralDate: values.initialReferralDate ? dayjs(values.initialReferralDate).format('YYYY-MM-DD') : '',
                consultReferral1Date: values.consultReferral1Date ? dayjs(values.consultReferral1Date).format('YYYY-MM-DD') : '',
                consultReferral2Date: values.consultReferral2Date ? dayjs(values.consultReferral2Date).format('YYYY-MM-DD') : '',
                consultReferral3Date: values.consultReferral3Date ? dayjs(values.consultReferral3Date).format('YYYY-MM-DD') : '',
                consultReferral4Date: values.consultReferral4Date ? dayjs(values.consultReferral4Date).format('YYYY-MM-DD') : '',
                ongoingReferral1Date: values.ongoingReferral1Date ? dayjs(values.ongoingReferral1Date).format('YYYY-MM-DD') : '',
                ongoingReferral2Date: values.ongoingReferral2Date ? dayjs(values.ongoingReferral2Date).format('YYYY-MM-DD') : '',
                ongoingReferral3Date: values.ongoingReferral3Date ? dayjs(values.ongoingReferral3Date).format('YYYY-MM-DD') : '',
                ongoingReferral4Date: values.ongoingReferral4Date ? dayjs(values.ongoingReferral4Date).format('YYYY-MM-DD') : '',
                addonReferral1Date: values.addonReferral1Date ? dayjs(values.addonReferral1Date).format('YYYY-MM-DD') : '',
                addonReferral2Date: values.addonReferral2Date ? dayjs(values.addonReferral2Date).format('YYYY-MM-DD') : '',
                addonReferral3Date: values.addonReferral3Date ? dayjs(values.addonReferral3Date).format('YYYY-MM-DD') : '',
                addonReferral4Date: values.addonReferral4Date ? dayjs(values.addonReferral4Date).format('YYYY-MM-DD') : '',
                supplementalDate1: values.supplementalDate1 ? dayjs(values.supplementalDate1).format('YYYY-MM-DD') : '',
                supplementalDate2: values.supplementalDate2 ? dayjs(values.supplementalDate2).format('YYYY-MM-DD') : '',
                supplementalDate3: values.supplementalDate3 ? dayjs(values.supplementalDate3).format('YYYY-MM-DD') : '',
                supplementalDate4: values.supplementalDate4 ? dayjs(values.supplementalDate4).format('YYYY-MM-DD') : '',
                dTServicesStartBy: values.dTServicesStartBy ? dayjs(values.dTServicesStartBy).format('YYYY-MM-DD') : '',
                dTInitialIFSPDateSOS: values.dTInitialIFSPDateSOS ? dayjs(values.dTInitialIFSPDateSOS).format('YYYY-MM-DD') : '',
                dTProviderSOSDate: values.dTProviderSOSDate ? dayjs(values.dTProviderSOSDate).format('YYYY-MM-DD') : '',
                dTDateAssigned: values.dTDateAssigned ? dayjs(values.dTDateAssigned).format('YYYY-MM-DD') : '',
                oTServicesStartBy: values.oTServicesStartBy ? dayjs(values.oTServicesStartBy).format('YYYY-MM-DD') : '',
                oTInitialIFSPDateSOS: values.oTInitialIFSPDateSOS ? dayjs(values.oTInitialIFSPDateSOS).format('YYYY-MM-DD') : '',
                oTProviderSOSDate: values.oTProviderSOSDate ? dayjs(values.oTProviderSOSDate).format('YYYY-MM-DD') : '',
                oTDateAssigned: values.oTDateAssigned ? dayjs(values.oTDateAssigned).format('YYYY-MM-DD') : '',
                pTServicesStartBy: values.pTServicesStartBy ? dayjs(values.pTServicesStartBy).format('YYYY-MM-DD') : '',
                pTInitialIFSPDateSOS: values.pTInitialIFSPDateSOS ? dayjs(values.pTInitialIFSPDateSOS).format('YYYY-MM-DD') : '',
                pTProviderSOSDate: values.pTProviderSOSDate ? dayjs(values.pTProviderSOSDate).format('YYYY-MM-DD') : '',
                pTDateAssigned: values.pTDateAssigned ? dayjs(values.pTDateAssigned).format('YYYY-MM-DD') : '',
                sTServicesStartBy: values.sTServicesStartBy ? dayjs(values.sTServicesStartBy).format('YYYY-MM-DD') : '',
                sTInitialIFSPDateSOS: values.sTInitialIFSPDateSOS ? dayjs(values.sTInitialIFSPDateSOS).format('YYYY-MM-DD') : '',
                sTProviderSOSDate: values.sTProviderSOSDate ? dayjs(values.sTProviderSOSDate).format('YYYY-MM-DD') : '',
                sTDateAssigned: values.sTDateAssigned ? dayjs(values.sTDateAssigned).format('YYYY-MM-DD') : '',
                quaterlyReport5Month: values.quaterlyReport5Month ? dayjs(values.quaterlyReport5Month).format('YYYY-MM-DD') : '',
                quarterlyReport10Month: values.quarterlyReport10Month ? dayjs(values.quarterlyReport10Month).format('YYYY-MM-DD') : '',
                otherReport: values.otherReport ? dayjs(values.otherReport).format('YYYY-MM-DD') : '',
                dischargeReport: values.dischargeReport ? dayjs(values.dischargeReport).format('YYYY-MM-DD') : '',
                referralStatus: values.referralStatus ? parseInt(values.referralStatus) : 0,
                county: values.county ? parseInt(values.county) : 0,
            };
            EditClient(highlighted.id, values)
                .then(res => {
                    if (res && res.data) {
                        SequentialMessageNotifier(formType, 'success');
                        handleAfterFormSubmit(res.data);
                        onClose();
                    }
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.ModelState) {
                            let obj = error.response.data.ModelState;
                            SequentialMessageNotifier(formType, 'error', obj);
                        } else if (error.response.data.Message) {
                            SequentialMessageNotifier(formType, 'error', error.response.data.Message);
                        }
                    }
                })
                .finally(() => {
                    setLoading(false)
                });
        });
    };

    const postRequest = () => {
        form.validateFields(allFormKeys).then(values => {
            SequentialMessageNotifier(formType);
            setLoading(true);
            values = {
                ...values,
                active: true,
                ifspDate: values.ifspDate ? dayjs(values.ifspDate).format('YYYY-MM-DD') : '',
                annualIFSPDate: values.annualIFSPDate ? dayjs(values.annualIFSPDate).format('YYYY-MM-DD') : '',
                dateOfBirth: values.dateOfBirth ? dayjs(values.dateOfBirth).format('YYYY-MM-DD') : '',
                ageOut: values.dateOfBirth ? dayjs(values.dateOfBirth).add(3, 'years').format('YYYY-MM-DD') : '',
                dTConsult: values.dTConsult ? dayjs(values.dTConsult).format('YYYY-MM-DD') : '',
                oTConsult: values.oTConsult ? dayjs(values.oTConsult).format('YYYY-MM-DD') : '',
                pTConsult: values.pTConsult ? dayjs(values.pTConsult).format('YYYY-MM-DD') : '',
                sTConsult: values.sTConsult ? dayjs(values.sTConsult).format('YYYY-MM-DD') : '',
                initialReferralDate: values.initialReferralDate ? dayjs(values.initialReferralDate).format('YYYY-MM-DD') : '',
                consultReferral1Date: values.consultReferral1Date ? dayjs(values.consultReferral1Date).format('YYYY-MM-DD') : '',
                consultReferral2Date: values.consultReferral2Date ? dayjs(values.consultReferral2Date).format('YYYY-MM-DD') : '',
                consultReferral3Date: values.consultReferral3Date ? dayjs(values.consultReferral3Date).format('YYYY-MM-DD') : '',
                consultReferral4Date: values.consultReferral4Date ? dayjs(values.consultReferral4Date).format('YYYY-MM-DD') : '',
                ongoingReferral1Date: values.ongoingReferral1Date ? dayjs(values.ongoingReferral1Date).format('YYYY-MM-DD') : '',
                ongoingReferral2Date: values.ongoingReferral2Date ? dayjs(values.ongoingReferral2Date).format('YYYY-MM-DD') : '',
                ongoingReferral3Date: values.ongoingReferral3Date ? dayjs(values.ongoingReferral3Date).format('YYYY-MM-DD') : '',
                ongoingReferral4Date: values.ongoingReferral4Date ? dayjs(values.ongoingReferral4Date).format('YYYY-MM-DD') : '',
                addonReferral1Date: values.addonReferral1Date ? dayjs(values.addonReferral1Date).format('YYYY-MM-DD') : '',
                addonReferral2Date: values.addonReferral2Date ? dayjs(values.addonReferral2Date).format('YYYY-MM-DD') : '',
                addonReferral3Date: values.addonReferral3Date ? dayjs(values.addonReferral3Date).format('YYYY-MM-DD') : '',
                addonReferral4Date: values.addonReferral4Date ? dayjs(values.addonReferral4Date).format('YYYY-MM-DD') : '',
                supplementalDate1: values.supplementalDate1 ? dayjs(values.supplementalDate1).format('YYYY-MM-DD') : '',
                supplementalDate2: values.supplementalDate2 ? dayjs(values.supplementalDate2).format('YYYY-MM-DD') : '',
                supplementalDate3: values.supplementalDate3 ? dayjs(values.supplementalDate3).format('YYYY-MM-DD') : '',
                supplementalDate4: values.supplementalDate4 ? dayjs(values.supplementalDate4).format('YYYY-MM-DD') : '',
                dTServicesStartBy: values.dTServicesStartBy ? dayjs(values.dTServicesStartBy).format('YYYY-MM-DD') : '',
                dTInitialIFSPDateSOS: values.dTInitialIFSPDateSOS ? dayjs(values.dTInitialIFSPDateSOS).format('YYYY-MM-DD') : '',
                dTProviderSOSDate: values.dTProviderSOSDate ? dayjs(values.dTProviderSOSDate).format('YYYY-MM-DD') : '',
                dTDateAssigned: values.dTDateAssigned ? dayjs(values.dTDateAssigned).format('YYYY-MM-DD') : '',
                oTServicesStartBy: values.oTServicesStartBy ? dayjs(values.oTServicesStartBy).format('YYYY-MM-DD') : '',
                oTInitialIFSPDateSOS: values.oTInitialIFSPDateSOS ? dayjs(values.oTInitialIFSPDateSOS).format('YYYY-MM-DD') : '',
                oTProviderSOSDate: values.oTProviderSOSDate ? dayjs(values.oTProviderSOSDate).format('YYYY-MM-DD') : '',
                oTDateAssigned: values.oTDateAssigned ? dayjs(values.oTDateAssigned).format('YYYY-MM-DD') : '',
                pTServicesStartBy: values.pTServicesStartBy ? dayjs(values.pTServicesStartBy).format('YYYY-MM-DD') : '',
                pTInitialIFSPDateSOS: values.pTInitialIFSPDateSOS ? dayjs(values.pTInitialIFSPDateSOS).format('YYYY-MM-DD') : '',
                pTProviderSOSDate: values.pTProviderSOSDate ? dayjs(values.pTProviderSOSDate).format('YYYY-MM-DD') : '',
                pTDateAssigned: values.pTDateAssigned ? dayjs(values.pTDateAssigned).format('YYYY-MM-DD') : '',
                sTServicesStartBy: values.sTServicesStartBy ? dayjs(values.sTServicesStartBy).format('YYYY-MM-DD') : '',
                sTInitialIFSPDateSOS: values.sTInitialIFSPDateSOS ? dayjs(values.sTInitialIFSPDateSOS).format('YYYY-MM-DD') : '',
                sTProviderSOSDate: values.sTProviderSOSDate ? dayjs(values.sTProviderSOSDate).format('YYYY-MM-DD') : '',
                sTDateAssigned: values.sTDateAssigned ? dayjs(values.sTDateAssigned).format('YYYY-MM-DD') : '',
                quaterlyReport5Month: values.quaterlyReport5Month ? dayjs(values.quaterlyReport5Month).format('YYYY-MM-DD') : '',
                quarterlyReport10Month: values.quarterlyReport10Month ? dayjs(values.quarterlyReport10Month).format('YYYY-MM-DD') : '',
                otherReport: values.otherReport ? dayjs(values.otherReport).format('YYYY-MM-DD') : '',
                dischargeReport: values.dischargeReport ? dayjs(values.dischargeReport).format('YYYY-MM-DD') : '',
                referralStatus: values.referralStatus ? parseInt(values.referralStatus) : 0,
                county: values.county ? parseInt(values.county) : 0,
            };
            CreateClient(values)
                .then(res => {
                    if (res && res.data) {
                        SequentialMessageNotifier(formType, 'success');
                        handleAfterFormSubmit(res.data);
                        onClose();
                    }
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.ModelState) {
                            let obj = error.response.data.ModelState;
                            SequentialMessageNotifier(formType, 'error', obj);
                        } else if (error.response.data.Message) {
                            SequentialMessageNotifier(formType, 'error', error.response.data.Message);
                        }
                    }
                })
                .finally(() => {
                    setLoading(false)
                });
        });
    }

    const onSubmit = () => {
        reusableSubmitValidatorWithKeys(allFormKeys, allFormKeys, formType, postRequest, putRequest, form);
    }

    const prev = () => {
        setPage(page - 1);
    }

    const next = () => {
        form.validateFields().then(() => {
            setPage(page + 1)
        })
    }

    let fieldsChanged = {}

    const onFormChange = (name, { changedFields, forms }) => {
        let changedField = changedFields[0].name[0];
        fieldsChanged[changedField] = true;
    }

    const onBlurChange = (id, value) => {
        switch (id) {
            case 'firstName1':
                if (value) form.setFieldsValue({ preferredName: value });
                break
            case 'ifspDate':
                if (value) {
                    const ifspDate = dayjs(value, 'YYYY-MM-DD');
                    const fiveMonthsLater = ifspDate.add(5, "month");
                    const tenMonthsLater = ifspDate.add(10, "month");

                    form.setFieldValue({ quaterlyReport5Month: fiveMonthsLater });
                    form.setFieldValue({ quarterlyReport10Month: tenMonthsLater })
                }
                break
        }
    }

    const steps = [
        {
            title: 'Personal',
            content: (
                <PersonalAndAddress form={form} onBlurChange={onBlurChange} formType={formType} />
            ),
        },
        {
            title: 'Guardians',
            content: (
                <Guardians form={form} />
            ),
        },
        {
            title: 'Services',
            content: (
                <Services form={form} formContext={formContext} setFormContext={setFormContext} />
            ),
        },
        {
            title: 'Therapists',
            content: (
                <Therapists form={form} formContext={formContext} setFormContext={setFormContext} />
            ),
        },
        {
            title: 'Languages',
            content: (
                <Languages form={form} />
            ),
        },
    ]

    return (
        <>
            <Modal
                title={
                    <Steps
                        style={{ borderRadius: '10px' }}
                        current={page}
                        onChange={stepNum => setPage(stepNum)}
                        direction="horizontal"
                    >
                        {steps.map(i => (
                            <Step className="step-title" key={i.title} title={i.title} />
                        ))}
                    </Steps>
                }
                onCancel={() => onClose()}
                open={visibility}
                onOk={() => onSubmit()}
                width="50%"
                closeIcon={false}
                maskClosable={false}
                footer={
                    <>
                        <Popconfirm title="Are you sure?" placement="bottomRight" onConfirm={() => onClose()}>
                            <Button loading={loading} type="primary" danger>
                                Cancel
                            </Button>
                        </Popconfirm>
                        <Button
                            type="primary"
                            loading={loading}
                            ghost
                            onClick={() => prev()}
                            style={{
                                display:
                                    page >= 1 ? '' : 'none',
                            }}
                        >
                            Previous
                        </Button>
                        <Button
                            type="primary"
                            loading={loading}
                            ghost
                            onClick={() => next()}
                            style={{
                                display:
                                    page === steps.length ? 'none' : '',
                            }}
                        >
                            Next
                        </Button>
                        <Button
                            type="primary"
                            loading={loading}
                            onClick={() => onSubmit()}
                        >
                            Submit
                        </Button>
                    </>
                }
            >
                <Form.Provider onFormChange={(name, { changedFields, forms }) => onFormChange(name, { changedFields, forms })} >
                    <div>
                        {steps[page]?.content}
                    </div>
                </Form.Provider>
            </Modal>
            <Modal
                title="Important Notes"
                open={notesVisible}
                okText="I affirm that I have read and understood the notes on this popup"
                onCancel={() => onNotesCancel()}
                onOk={() => onNotesAcknowledge()}
            >
                <Card size='small' className='formCard'>
                    {highlighted?.notes}
                </Card>
            </Modal>
        </>
    )
}

export default ClientForm;